module.exports = __webpack_public_path__ + "img/ditu.161fddc7.png";